// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__K83N8","empty":"ModalGraph_empty__lT_0L"};